import React, { useState, useEffect } from "react";
import { useNavigate, Link, useSearchParams } from "react-router-dom";
import { Lock, ArrowLeft } from "lucide-react";
import { api } from "../lib/api";
import { toast } from "sonner";
import BrandMark from "../components/BrandMark";

const AdminLogin = () => {
    const nav = useNavigate();
    const [params] = useSearchParams();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (params.get("expired") === "1") {
            toast.info("Sua sessão expirou. Faça login novamente.");
        }
    }, [params]);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const { data } = await api.post("/auth/login", { email, password });
            localStorage.setItem("admin_token", data.token);
            localStorage.setItem("admin_email", data.email);
            toast.success("Login realizado!");
            nav("/admin");
        } catch (err) {
            toast.error(err.response?.data?.detail || "Credenciais inválidas");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div data-testid="admin-login-page" className="min-h-screen bg-brand-bg flex items-center justify-center px-4">
            <div className="w-full max-w-md">
                <Link to="/" data-testid="admin-back-home" className="inline-flex items-center gap-2 text-sm text-brand-inkSoft hover:text-brand-ink mb-6">
                    <ArrowLeft className="w-4 h-4" /> Voltar para a loja
                </Link>
                <div className="bg-white border border-brand-border p-8 sm:p-10 rounded-sm shadow-sm">
                    <BrandMark size={56} bgClass="bg-brand-ink" colorClass="text-brand-gold" className="mb-5" />
                    <div className="flex items-center gap-2 text-[10px] uppercase tracking-[0.25em] text-brand-gold font-bold mb-1" data-testid="admin-restricted-label">
                        <Lock className="w-3 h-3" /> Acesso restrito
                    </div>
                    <h1 className="font-heading font-bold text-2xl text-brand-ink">Painel Administrador</h1>
                    <p className="text-sm text-brand-inkSoft mt-1">Gestão da loja Vitrine Deus Proverá.</p>
                    <form onSubmit={submit} className="mt-8 space-y-4">
                        <div>
                            <label className="block text-xs font-bold uppercase tracking-wider text-brand-ink mb-1.5">Email</label>
                            <input
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                data-testid="admin-email-input"
                                className="w-full border border-brand-border focus:border-brand-ink outline-none px-4 py-3 text-sm rounded-sm bg-white transition-colors"
                                placeholder="admin@vitrinedeusprovera.com"
                            />
                        </div>
                        <div>
                            <label className="block text-xs font-bold uppercase tracking-wider text-brand-ink mb-1.5">Senha</label>
                            <input
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                data-testid="admin-password-input"
                                className="w-full border border-brand-border focus:border-brand-ink outline-none px-4 py-3 text-sm rounded-sm bg-white transition-colors"
                                placeholder="••••••••"
                            />
                        </div>
                        <button
                            type="submit"
                            disabled={loading}
                            data-testid="admin-submit-btn"
                            className="w-full bg-brand-ink text-white hover:bg-brand-dark transition-colors py-3.5 font-heading font-semibold rounded-sm disabled:opacity-60"
                        >
                            {loading ? "Entrando…" : "Entrar"}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default AdminLogin;
